import * as React from "react"
import { Appearance, ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { color } from "../../../theme"
import { FastField, FieldProps } from "formik"
import { FormControl, FormControlProps } from "../../form-control/form-control"
import _ from "lodash"
import { TxKeyPath } from "../../../i18n"
import { Picker, PickerProps } from "../../picker/picker"
import en from "../../../i18n/en"
import { FC, useCallback } from "react"
import { FastFieldProps } from "formik/dist/FastField"

export interface PickerFieldProps {
  FieldComponent?: React.ComponentType<any>,
  name: string,
  colorScheme?: "light" | "dark",
  txPrefix?: keyof typeof en,
  formControlProps?: FormControlProps,
  pickerProps?: PickerProps
}

const FORM_CONTROL: ViewStyle = {
  paddingHorizontal: 16,
  // marginBottom: 8
  paddingBottom: 8,
  backgroundColor: color.palette.white
}

const PickerFormControl: FC<Omit<PickerFieldProps, "FieldComponent"|"name"> & (FastFieldProps | FieldProps)> = observer(function PickerFormControl(props) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    txPrefix,
    formControlProps, pickerProps,
    field, form: { setFieldValue, setFieldTouched }, meta
  } = props;

  
  const column = field.name.split('.').pop()

  const onValueChange = useCallback(async (value) => {
    await setFieldValue(field.name, value || null)
    await setFieldTouched(field.name)
  }, [field.name, setFieldTouched, setFieldValue])

  return (<FormControl
    isInvalid={(meta.initialValue || meta.touched) && !!meta.error}
    labelTx={(txPrefix && `${txPrefix}.${_.camelCase(column)}` as TxKeyPath) || undefined}
    colorScheme={colorScheme}
    labelColor={color.palette.gray800}
    errorMessage={meta.error}
    style={FORM_CONTROL}
    {...formControlProps}
  >
    <Picker
      testID={`jala:id/${field.name}-input`}
      colorScheme={colorScheme}
      placeholderTx={(txPrefix && `${txPrefix}.${_.camelCase(column)}Placeholder` as TxKeyPath) || undefined}
      value={field.value}
      onValueChange={onValueChange}
      isUseSearch={false}
      clearable={true}
      {...pickerProps}
    />
  </FormControl>);
})

/**
 * Describe your component here
 */
export const PickerField = observer(function PickerField(props: PickerFieldProps) {
  const {
    FieldComponent = FastField,
    name, colorScheme = "light" || Appearance.getColorScheme(),
  } = props

  return (
    <FieldComponent name={name}>
      {(fieldProps) => (
        <PickerFormControl colorScheme={colorScheme} {...props} {...fieldProps} />
      )}
    </FieldComponent>
  )
})
